import React, {useEffect, useRef, useState} from 'react'

import t from 'helpers/I18n'

import PropTypes from 'prop-types';
import StepsLoader from "../steps-loader";
import BaseParagraph from "../../base-components/base-paragraph";
import InputField from "../../base-components/base-input";
import StepFooterAction from "../../base-components/step-footer-action";
import BottomSheet from '../../modals/bottom-sheet';
import { HiOutlineLightBulb } from 'react-icons/hi'
import { BASE_URL } from '../../../env';

// HiOutlineLightBulb

const EnterpriseName = ({ _step_service, error, step_ID, step_URL, next_step, step_form, setDataToContext, getDataFromContext }) => {
    const base_URL = `${BASE_URL}/onboarding-entrepreneur-front/v1/step`
    const name = step_ID
    const checkboxID = "enterprise_name_use_fullname"
    const form = useRef()
    const data = getDataFromContext(step_ID)
    const [isLoading, setIsLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [inputData, setInputData] = useState({ ...data })
    const [isValid, setIsValid] = useState(false)
    const [useFullName, setUseFullName] = useState(false)
    const [fullName, setFullName] = useState("")
    const [nextTick, setNextTick] = useState(false)

    const fetch_GET_init_options = {
        method: 'GET',
        credentials: "include",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',            
        }
    }

    async function concatFullName() {
        console.log('doing the call in')
        const firstName = (await (await fetch(`${base_URL}/first_name`, fetch_GET_init_options)).json()).fieldValue
        const lastName = (await (await fetch(`${base_URL}/last_name`, fetch_GET_init_options)).json()).fieldValue
        setFullName(`${firstName} ${lastName}`)
    }

    async function getData() {
        const name = await (await fetch(`${base_URL}/enterprise_name`, fetch_GET_init_options)).json()
        const useFullName = await (await fetch(`${base_URL}/enterprise_name_use_fullname`, fetch_GET_init_options)).json()

        if (name.fieldValue !== 'NULL') {
             setInputData({...inputData, 
                enterprise_name: name.fieldValue,
                enterprise_name_use_fullname: useFullName.fieldValue !== "-1" ? useFullName.fieldValue : 0
            })
        }   
    }

    useEffect(() => {
        concatFullName()
        getData()
    }, [])
  
    const getInputValue = (name, value) => {
        console.log('here again')
        console.log("data = ", data)
        console.log("inputData = ", inputData)
        console.log("value => ", value)
        
        // if (value !== "") {
            setInputData({
                ...inputData,
                [name] : value
            })
            // setDataToContext(step_ID, step_URL, name, value)
        // }

        if (name === checkboxID && value === 1  ) {
            // setDataToContext(step_ID, step_URL, step_ID, fullName)
            setInputData({
            ...inputData,
                [step_ID]: fullName,
                [name] : value
            })
            setUseFullName(true)
        } else if ((name === checkboxID && value === 0) || (name === checkboxID && value === "0")) {
            setUseFullName(false)
        } else if (name === checkboxID && value === 1 && data[step_ID] !== "") {
            setUseFullName(true)
        }
    }

    useEffect(() => {
        setIsValid(
            inputData[checkboxID] === 1
            || (inputData[step_ID] !== ""
                && inputData[step_ID] !== undefined
                && inputData[step_ID] !== " "))
    }, [inputData])

    const action = () => {
        setDataToContext(step_ID, step_URL, step_ID, inputData[step_ID])
        setDataToContext(step_ID, step_URL, checkboxID, inputData[checkboxID])
        setNextTick(true)
    }

    useEffect(() => {
        if (nextTick) {
            _step_service({step_ID, setIsLoading, next_step: "establishment-date"})
        }
    }, [nextTick])

    
    useEffect(() => {
            if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
                    pageID: "onboarding",
                    stepSeq: "3",
                    stepName: "pro info:what is your company name",
                    flowType: "sales",
                    flowName: "onboarding",
                    productName: "onboarding",
                    trackMethod: "flow"
                    }
                );
            }

     }, [])

    return (
        <>
            <StepsLoader step_ID={step_ID} loading={isLoading}>
                <form ref={form}>
                    <BaseParagraph>
                        <h3>{t('pro_infos.pro_info_what_is_your_company_name.title')}</h3>
                        <a className={"link"} onClick={() => setShowModal(true)}>
                            <HiOutlineLightBulb /> <span>{ t('pro_infos.pro_info_what_is_your_company_name.tool_tip')}</span> </a>
                        <br/>
                        <br/>
                        
                        <InputField
                            label={t('pro_infos.pro_info_what_is_your_company_name.label')}
                            value={inputData[step_ID]}
                            id={name}
                            name={name}
                            getInputValue={getInputValue}
                            error={error}
                            getDataFromContext={getDataFromContext}
                            disabled={useFullName}
                            max={200}
                        />
                        <InputField
                            checkboxLabel={t('pro_infos.pro_info_what_is_your_company_name.opt_in')}
                            type={"checkbox"}
                            value={inputData[checkboxID]}
                            name={checkboxID}
                            id={checkboxID}
                            getInputValue={getInputValue}
                            error={error}
                            checked={Number(inputData[checkboxID])}
                            getDataFromContext={getDataFromContext}
                        />
                    </BaseParagraph>
                </form>

                <StepFooterAction caption={t('general.continue')} action={action} link={next_step} disabled={!isValid} />
                
                {showModal &&
                <BottomSheet title={""} close={() => {setShowModal(false)}}>
                    <BaseParagraph>
                        <p>{ t('pro_infos.pro_info_what_is_your_company_name.modal.text')}</p>
                    </BaseParagraph>
                </BottomSheet>}
            </StepsLoader>
        </>
    )
}

EnterpriseName.propTypes = {
    name: PropTypes.string
}

EnterpriseName.defaultProps = {
    name: "email-step"
}

export default EnterpriseName